export default __webpack_public_path__ + "media/plus/plus-password-34f7c2d5.png";